module.exports = __webpack_public_path__ + "public/SiteIcons/avatar.png?6dd2424f";